import {
  Component,
  OnInit,
  OnDestroy,
  HostListener,
  ElementRef,
} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ThemeCustomizerService } from '../theme-customizer/theme-customizer.service';

@Component({
  selector: 'app-header-style-seven',
  templateUrl: './header-style-seven.component.html',
  styleUrls: ['./header-style-seven.component.scss'],
})
export class HeaderStyleSevenComponent implements OnInit, OnDestroy {
  isSticky = false;
  newsItems: string[] = [];
  currentNewsIndex = 0;
  newsInterval: ReturnType<typeof setInterval> | null = null;
  apiUrl = 'https://fmcet.ac.in/backend/getNews.php';

  classApplied = false;
  classApplied2 = false;
  classApplied3 = false;

  isMobileView = false;
  private openDropdownKeys = new Set<string>();
counsellingCode = '5935';
  constructor(
    private http: HttpClient,
    public themeService: ThemeCustomizerService,
    private elementRef: ElementRef<HTMLElement>
  ) {}

  @HostListener('window:scroll')
  onScroll(): void {
    this.isSticky = window.scrollY > 50;
  }

  @HostListener('window:resize')
  onResize(): void {
    this.updateViewportState();

    if (!this.isMobileView) {
      this.classApplied = false;
      this.openDropdownKeys.clear();
      this.toggleBodyScroll(false);
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.isMobileView || !this.classApplied) return;

    const target = event.target as Node | null;

    if (target && !this.elementRef.nativeElement.contains(target)) {
      this.closeMobileMenu();
    }
  }

  ngOnInit(): void {
    this.updateViewportState();
    this.onScroll();
    this.loadNews();
  }

  ngOnDestroy(): void {
    this.clearNewsRotation();
    this.toggleBodyScroll(false);
  }

  loadNews(): void {
    this.http.get<string[]>(this.apiUrl).subscribe({
      next: (data) => {
        this.newsItems =
          Array.isArray(data) && data.length ? data : ['No news available'];
        this.currentNewsIndex = 0;
        this.startNewsRotation();
      },
      error: (error) => {
        console.error('Error loading news:', error);
        this.newsItems = ['Error loading news.'];
        this.currentNewsIndex = 0;
        this.clearNewsRotation();
      },
    });
  }

  startNewsRotation(): void {
    this.clearNewsRotation();

    if (!this.newsItems.length || this.newsItems.length === 1) return;

    this.newsInterval = setInterval(() => {
      this.currentNewsIndex =
        (this.currentNewsIndex + 1) % this.newsItems.length;
    }, 4000);
  }

  clearNewsRotation(): void {
    if (this.newsInterval) {
      clearInterval(this.newsInterval);
      this.newsInterval = null;
    }
  }

  toggleClass(): void {
    this.classApplied = !this.classApplied;

    if (!this.classApplied) {
      this.openDropdownKeys.clear();
    }

    this.toggleBodyScroll(this.classApplied && this.isMobileView);
  }

  toggleClass2(): void {
    this.classApplied2 = !this.classApplied2;
  }

  toggleClass3(): void {
    this.classApplied3 = !this.classApplied3;
  }

  toggleMobileDropdown(key: string, event: Event): void {
    if (!this.isMobileView) return;

    event.preventDefault();
    event.stopPropagation();

    if (this.openDropdownKeys.has(key)) {
      this.openDropdownKeys.delete(key);
    } else {
      this.openDropdownKeys.add(key);
    }
  }

  isDropdownOpen(key: string): boolean {
    return this.openDropdownKeys.has(key);
  }

  onMenuLinkClick(): void {
    if (!this.isMobileView) return;
    this.closeMobileMenu();
  }

  private closeMobileMenu(): void {
    this.classApplied = false;
    this.openDropdownKeys.clear();
    this.toggleBodyScroll(false);
  }

  private updateViewportState(): void {
    this.isMobileView = window.innerWidth <= 991;

    if (!this.isMobileView) {
      this.openDropdownKeys.clear();
      this.toggleBodyScroll(false);
    }
  }

  private toggleBodyScroll(lock: boolean): void {
    document.body.style.overflow = lock ? 'hidden' : '';
  }
}